export default {
  SEARCH_CUSTOMER_KUSPIT_MOVEMENTS_QUERY: Symbol.for('SEARCH_CUSTOMER_KUSPIT_MOVEMENTS_QUERY'),
  CUSTOMER_KUSPIT_MOVEMENT_REPOSITORY: Symbol.for('CUSTOMER_KUSPIT_MOVEMENT_REPOSITORY'),
  CUSTOMER_KUSPIT_MOVEMENT_STATE_MANAGER: Symbol.for('CUSTOMER_KUSPIT_MOVEMENT_STATE_MANAGER'),
};
